import { Box, Center, VStack } from 'native-base';
import * as React from 'react';
import UserJobHistoryList from 'src/components/list/UserJobHistoryList';
import FilterModal from 'src/components/modal/FilterModal';
import { containerStyle } from 'src/styles/containerStyle';
import { useResponsive } from 'src/hooks/useResponsive';

const DESKTOP_MAX_CONTENT_WIDTH = "1200px";

export default function ReadingsPage({ navigation }: { navigation: any }) {
    const { isLargeScreen } = useResponsive();
    
    return (
        <Box variant={"main"} style={containerStyle.mainContainer}>
            <FilterModal />
            {isLargeScreen ? (
                <Center flex={1}>
                    <VStack w="100%" maxW={DESKTOP_MAX_CONTENT_WIDTH} flex={1}>
                        <UserJobHistoryList pageType='tabs' navigation={navigation} />
                    </VStack>
                </Center>
            ) : (
                <UserJobHistoryList pageType='tabs' navigation={navigation} />
            )}
        </Box>
    );
}